import { fetchConfigDetailedReport } from '../api/index.js';
import { mapSection } from '../helpers/detailed-report.helper.js'

export async function getConfigDetailedReport(projectId) {
  try {
    const configDetailedReport = await fetchConfigDetailedReport(projectId);

    if (configDetailedReport) {
      let sections = []
      configDetailedReport.sections
        .filter(s => s.customizationType === 'user-editable')
        .forEach(section => {
        sections.push(mapSection(section));
      });

      return sections;
    }

    return []
  } catch (e) {
    console.error("Error manipular configuracion para reporte detallado", e);
    throw e;
  }
}